"use strict";
/**
 * @module Services.RemoteServers
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var remote_servers_1 = require("../../../features/remote-servers");
var BEES = require("../../serialisers/byte-encoded-enum-serialiser");
/**
 * Read a remote server status from the stream
 *
 * @param bis  the input stream
 * @return     the {@link RemoteServerStatus} that was read
 */
function readRemoteServerStatus(bis) {
    var connectionState = BEES.read(bis, remote_servers_1.ConnectionState);
    var failureMessage = Codec.readString(bis);
    return {
        connectionState: connectionState,
        failureMessage: failureMessage
    };
}
exports.readRemoteServerStatus = readRemoteServerStatus;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/read-remote-server-status.js
// module id = 1372
// module chunks = 1